import {JSONContent} from '@tiptap/react';
import {Roster, User} from '@/api/dto/dto';

export enum MessageThreadScope {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export interface MessageThreadSummaries {
  rosterTotal: number;
  hasMore: boolean;
  messageThreadSummaries: MessageThreadSummary[];
}

export interface MessageThreadSummary {
  id: number;
  clientId: string;
  roster?: Roster;
  careJourneyInstanceId?: string;
  referralId?: string;
  unitId?: string;
  scope: MessageThreadScope;
  subject: string | null;
  muted?: boolean;
  latestMessage: Message;
  lastSeenMessage?: Message;
  unread?: number;
  about?: string;
  units?: string[];
  users: User[];
  attachments: MessageAttachment[];
}

export interface MessageThread {
  id: number;
  clientId: string;
  careJourneyInstanceId?: string;
  referralId?: string;
  unitId?: string;
  scope: MessageThreadScope;
  subject: string | null;
  messages: Message[];
}

export interface Message {
  id: number;
  messageThread?: MessageThread;
  user: User;
  content: JSONContent;
  attachments: MessageAttachment[];
  createdAt: string;
}

export interface MessageAttachment {
  id: number;
  messageId: number;
  s3Key: string;
}

export interface MessageThreadPatch {
  subject?: string;
  muted?: boolean;
}
